export default "__VITE_ASSET__ef6fd403__"